import { useEffect } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useTranslation } from "next-i18next";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import BreadcrumbsComponent from "@atoms/Breadcrumbs/Breadcrumbs";
import Text from "@ds/components/Text";
import color from "@definitions/mui/color";
import { gtmCustomEvent } from "@helpers/analytics";
import FormInterest from "../../form";
import type { TInterestFormProps } from "../../type";
import useStyles from "./styles";

const InterestFormLevelOne: React.FC<TInterestFormProps> = (props) => {
  const {
    id: productId,
    productName,
    // masterProductId,
    // parentProductId,
    // level,
    breadcrumbs,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation("common");
  const productFields = {
    productName,
    productId,
    // masterProductId,
    // parentProductId,
    // level,
  };

  useEffect(() => {
    const timeoutFetch = setTimeout(() => {
      gtmCustomEvent(
        {
          eventAction: `Akses Interest Form - Produk ${productName}`,
          eventCategory: "WebPages",
          eventLabel: `Interest Form - Produk ${productName}`,
        },
        "LeadProduct",
      );
    }, 1000);
    return () => window.clearTimeout(timeoutFetch);
  }, [productName]);

  return (
    <GoogleReCaptchaProvider reCaptchaKey={`${process.env.NEXT_PUBLIC_SITE_KEY}`}>
      <Box position="relative">
        <Box bgcolor={color.grey.mid} width="100%" mt={9}>
          <Container maxWidth="lg" disableGutters className={classes.bcSpaced}>
            <BreadcrumbsComponent
              homeUrl={{ label: t("root"), productPath: "/" }}
              breadcrumbs={breadcrumbs}
              lastUrl={{ label: "Interested Form" }}
            />
          </Container>
        </Box>
        <Box bgcolor="white" pt={8} pb={12}>
          <Box maxWidth="640px" margin="auto">
            <Text className={classes.title} align="center" variant="h1" weight="700">
              {t("pdp.interest.title")}{` `}{`${productName}`}
            </Text>
            <Text align="center" component="p" color="inactive-secondary" variant="body1">
              {t("pdp.interest.desc")}
            </Text>
            <FormInterest productName={productName} products={productFields} />
          </Box>
        </Box>
      </Box>
    </GoogleReCaptchaProvider>
  );
};

export default InterestFormLevelOne;
